import { executePrint } from '../../../store/bulk/print/bulk.print.actions';

export const RequestGetFulfillmentsStep = (state, jobId) => {
  return [executePrint(jobId)];
};
